<template>
      <StudentTablePayment :school="school" v-if="school"></StudentTablePayment>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("@/firebaseConfig.js");

export default {
  data: () => ({
    school: null,
    stab: null,
    collectionName: "students",
    title: "Students",
  }),
  components: {
    StudentTablePayment: () => import("@/views/students/StudentTablePayment"),
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    yyschool() {
      return fb.yyschool;
    },
  },
  created() {
    this._read();
  },
  methods: {
    _read() {
      fb.db
        .doc(this.yyschool)
        .get()
        .then((doc) => {
          let school = doc.data();
          school.id = doc.id;
          school.ref = doc.ref;
          this.school = school;
        });
    },
  },
};
</script>
